import cookie from 'js-cookie'
import assets from 'modules/assets'

function URL(props) {
  // TODO: lang is not being passed down. Debug
  let { lang } = props
  var language = cookie.get('lang') || (window.navigator.userLanguage || window.navigator.language).split('-')[0]

  // TODO: confirm that cookie is set
  if(lang) {
    language = lang
    cookie.set('lang', lang, { expires: 300 })
  }

  let src = props.loc || props.route.path

  // TODO: add language support & refactor this
  switch (src) {
    case '/our-story':
      src = 'about.md'
      break
    case '/team':
      src = 'team/index.md'
      break
    case '/camps':
      src = 'camps.md'
      break
    case '/newyork':
      src = 'house.md'
      break
    case '/digital':
      src = 'digital.md'
      break
    case '/get-involved':
      src = 'get-involved.md'
      break
    case '/apply':
      src = 'camps.md'
      break
    default:
      src = 'index.md'
      break
  }
  // let localFile = (src ? src + '/' : '') + language + '.md'
  // let file = (src ? src + '/' : '') + 'index.md'
  // assets(localFile) || assets(file)

  let url = assets(src)
  return url
}

module.exports = URL



// WEBPACK FOOTER //
// ./src/modules/url.js